import React, { useEffect, useState } from "react";
import api from "../api";
import ServiceCard from "../components/ServiceCard";
import { SectionTitle, usePageTitle, MedicalWarning } from "../components/common";

export default function Energetique() {
  usePageTitle("L'Énergétique");
  const [services, setServices] = useState([]);
  useEffect(() => {
    api.get("/services?category=energetique").then((r) => setServices(r.data)).catch(() => {});
  }, []);
  return (
    <div className="home-dark min-h-[80vh]">
      <div className="container-x py-12 sm:py-20 fade-up">
        <SectionTitle
          eyebrow="Bien-être & introspection"
          title="L'Énergétique"
          sub="Des séances énergétiques réalisées à distance dans une approche intuitive, spirituelle et tournée vers le bien-être et l'introspection."
        />
        <div className="mt-8 max-w-3xl">
          <MedicalWarning tone="light" text="Ces séances relèvent exclusivement du bien-être, de la spiritualité et de l'introspection. Elles ne constituent en aucun cas un acte médical, un diagnostic ou un traitement et ne remplacent jamais un suivi auprès d'un professionnel de santé." />
        </div>
        <div className="mt-10 grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {services.map((s) => (
            <ServiceCard key={s.slug} service={s} />
          ))}
        </div>
      </div>
    </div>
  );
}
